import {
  gameCategories as fetchCategories,
  useApi,
} from '@repo-level/core-front';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useCollections = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const [requestGameCategories, { data = [], pending, error }] =
    useApi(fetchCategories);

  const collections = useMemo(
    () => new Map(data.map((category) => [category.id, category])),
    [data]
  );

  useEffect(() => {
    requestGameCategories(language);
  }, [language, requestGameCategories]);

  return {
    pending,
    isError: !!error,
    collections,
  };
};
